function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { Divider } from "../../elements/Divider";
import { FlexContainer } from "../../layout/FlexContainer";
import { Grid } from "../../layout/Grid";
import { Heading } from "../../typography/Heading";
import { Checkbox } from "../../inputs/Checkbox";
import { GridColumn } from "../../layout/GridColumn";
import { withResponsive } from "../../../utils/with-responsive";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { getGridColumns } from "./utils/getGridColumns";

var Component = function Component(_ref) {
  var heading = _ref.heading,
      checkboxes = _ref.checkboxes,
      isUserOnMobile = _ref.isUserOnMobile;
  return React.createElement(Segment, {
    className: "is-input-segment is-checkbox-input-segment",
    vertical: true
  }, React.createElement(FlexContainer, {
    alignItems: "baseline",
    flexDirection: "column",
    justifyContent: "space-between"
  }, React.createElement(Heading, null, heading), React.createElement(Divider, {
    size: "small"
  }), React.createElement(Grid, {
    columns: getGridColumns(isUserOnMobile)
  }, checkboxes.map(function (_ref2) {
    var name = _ref2.name,
        label = _ref2.label,
        checkboxProps = _objectWithoutProperties(_ref2, ["name", "label"]);

    return React.createElement(GridColumn, {
      key: buildKeyFromStrings(label, name)
    }, React.createElement(Checkbox, _extends({
      label: label,
      name: name
    }, checkboxProps, {
      isFluid: isUserOnMobile,
      isLabelLeft: isUserOnMobile
    })));
  }))));
};

Component.displayName = 'CheckboxInputSegment';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired,
  heading: PropTypes.string.isRequired,
  isUserOnMobile: PropTypes.bool.isRequired
} : {};
export var ComponentWithResponsive = withResponsive(Component);